// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UnderlineOutlinedSvg from "@ant-design/icons-svg/es/asn/UnderlineOutlined";
import AntdIcon from '../components/AntdIcon';

var UnderlineOutlined = function UnderlineOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UnderlineOutlinedSvg
  }));
};

UnderlineOutlined.displayName = 'UnderlineOutlined';
export default React.forwardRef(UnderlineOutlined);